import type { Permission } from "../../shared/rbac/permissions";
import type { UserFacingMessageParts } from "../../shared/userFacingError";

const PERMISSION_LABELS: Record<Permission, string> = {
  allow_all: "Full tenant access",
  "space:read": "View spaces",
  "space:write": "Edit space workflows",
  "space:push_live": "Push workflows live",
  "space:manage": "Manage space access",
  "connected_app:read": "View connector settings",
  "connected_app:write": "Edit connector settings",
  "connected_app:share": "Manage connector access",
  "connected_app:use": "Use connectors in workflows",
  "skill:read": "View skills",
  "skill:write": "Manage skill access",
  "network:read": "View network",
  "network:write": "Manage network",
  "network:use": "Use network",
  "user_group:read": "View group members",
  "user_group:write": "Manage group access",
  "service_account:read": "View service account",
  "service_account:assume": "Get temporary credentials",
  "service_account:manage": "Manage service account",
  "oidc_provider:manage": "Manage OIDC provider",
  "tenant:connected_app_create": "Create connectors",
  "tenant:skill_create": "Create skills",
  "tenant:network_create": "Create networks",
  "tenant:service_account_create": "Create service accounts",
  "tenant:service_accounts_read": "View all service accounts",
  "tenant:connected_apps_read": "View all connectors",
  "tenant:connected_app_share": "Share connectors you create",
  "tenant:skills_read": "View all skills",
  "tenant:space_create": "Create spaces",
  "tenant:spaces_read": "View all spaces",
  "tenant:spaces_manage": "Manage all spaces",
  "tenant:user_group_create": "Create groups",
  "tenant:users_manage": "Manage members",
  "tenant:audit_logs_read": "View audit logs",
  "tenant:audit_logs_manage": "Manage audit log destinations",
  "tenant:ai_providers_manage": "Manage AI providers",
  "tenant:sso_manage": "Manage SSO",
  "tenant:oidc_providers_manage": "Manage OIDC providers",
  "tenant:feature_flags_manage": "Manage feature flags",
  "tenant:personal_chats_read": "View all personal chats",
  "tenant:roles_manage": "Manage roles",
  "tenant:networks_manage": "Manage networks",
  "tenant:egress_routes_manage": "Manage egress routes",
  "tenant:egress_rules_manage": "Manage egress rules",
};

export function permissionLabel(permission: string): string {
  return Object.hasOwn(PERMISSION_LABELS, permission)
    ? PERMISSION_LABELS[permission as Permission]
    : permission;
}

export function formatPermissionMessage(parts: UserFacingMessageParts): string {
  return parts
    .map((part) =>
      typeof part === "string" ? part : permissionLabel(part.permission)
    )
    .join("");
}
